import React from "react";
import { STATUS_STYLES } from "@/lib/api";
import { PUBLIC_TRACK } from "@/constants/testIds";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, className }) => {
  const s = STATUS_STYLES[status] || STATUS_STYLES.Created;
  return (
    <span
      data-testid={PUBLIC_TRACK.statusBadge}
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-mono font-semibold uppercase tracking-wider",
        s.chip,
        className
      )}
    >
      <span className={cn("h-2 w-2 rounded-full", s.dot)} />
      {status}
    </span>
  );
};
